module.exports = __webpack_public_path__ + "img/Untitled-alkhalil.3e39b1d2.png";